import uiActionTypes from '../action_types/ui-action-types'

export const closeModal = () => ({
	type: uiActionTypes.closeModal
})

export const openModal = payload => ({
	type: uiActionTypes.setModal,
	payload
})

export const hidePopuptop = () => ({
	type: uiActionTypes.closePopupTop
})

export const openPopuptop = payload => ({
	type: uiActionTypes.setPopupTop,
	payload
})

export const showLoading = payload => ({
	type: uiActionTypes.showLoading,
	payload
})

export const setInstallPrompt = payload => ({
	type: uiActionTypes.setInstallPrompt,
	payload
})

export const setControllerBack = payload => ({
	type: uiActionTypes.setControlBack,
	payload
})

export const resetControllerBack = () => ({
	type: uiActionTypes.resetControlBack
})

export const toggleSlideMenu = () => ({
	type: uiActionTypes.toggleSliderMenu
})

export const toggleMenu = payload => ({
	type: uiActionTypes.toggleMenu,
	payload
})

export const openOverlay = payload => ({
	type: uiActionTypes.openOverlay,
	payload
})

export const closeOverlay = () => ({
	type: uiActionTypes.closeOverlay
})

export const handledNavBar = payload => ({
	type: uiActionTypes.handledNavBar,
	payload
})

export const handleShowIconCloseModal = payload => ({
	type: uiActionTypes.showIconCloseModal,
	payload
})
